var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{class:_vm.classes,attrs:{"to":_vm.toValue}},[_vm._v(_vm._s(_vm.name)),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }